export default __webpack_public_path__ + "0b2c87a8792c7a2c5a04a43507c3baa0.otf";